enum Phases {
  A1A3 = 0,
  A1,
  A2,
  A3,
  A4,
  A5,
  B1,
  B2,
  B3,
  B4,
  B5,
  B6,
  B7,
  C1,
  C2,
  C3,
  C4,
  D,
}

const getIncludedPhasesAsEnum = (includedPhases: string[]) => {
  return includedPhases.map((phase: string) => Phases[phase as keyof typeof Phases]);
};

const getIncludedPhasesAsName = (includedPhases: number[]) => {
  return includedPhases.map((phase: number) => Phases[phase]);
};

export { getIncludedPhasesAsEnum, getIncludedPhasesAsName };
